module.exports = __webpack_public_path__ + "img/top01.e50bf0da.svg";